import { ChatSession } from "../types/chat";
import { fetchClient } from "../utils/fetchClient";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api";
const WS_BASE_URL = process.env.REACT_APP_WS_BASE_URL || "ws://localhost:8000";

class ChatService {
  private getAuthHeaders(token: string) {
    const tid = localStorage.getItem("tenantId");
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...(tid ? { "X-Tenant-Id": tid } : {}),
    };
  }

  async getChatSessions(
    token: string,
    page: number = 1,
    pageSize: number = 20,
  ): Promise<any> {
    try {
      console.log(
        "Fetching chat sessions with token:",
        token ? "Token present" : "No token",
      );

      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());

      const response = await fetchClient(
        `${API_BASE_URL}/chat/?${params.toString()}`,
        {
          headers: this.getAuthHeaders(token),
        },
      );

      console.log("Chat sessions response status:", response.status);
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Chat sessions error response:", errorText);
        throw new Error(`Failed to fetch chat sessions: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching chat sessions:", error);
      throw error;
    }
  }

  async createChatSession(token: string, title?: string): Promise<ChatSession> {
    try {
      const response = await fetchClient(`${API_BASE_URL}/chat/create/`, {
        method: "POST",
        headers: this.getAuthHeaders(token),
        body: JSON.stringify({
          title: title || "New Chat",
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to create chat session");
      }

      return await response.json();
    } catch (error) {
      console.error("Error creating chat session:", error);
      throw error;
    }
  }

  async getChatMessages(token: string, sessionId: string): Promise<any> {
    try {
      console.log("Fetching messages for chat session:", sessionId);
      const response = await fetchClient(`${API_BASE_URL}/chat/${sessionId}`, {
        headers: this.getAuthHeaders(token),
      });

      console.log("Get messages response status:", response.status);
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Get messages error response:", errorText);
        throw new Error(`Failed to fetch chat messages: ${response.status}`);
      }

      const data = await response.json();
      console.log("Chat messages data:", data);
      return data;
    } catch (error) {
      console.error("Error fetching chat messages:", error);
      throw error;
    }
  }

  async deleteChatSession(token: string, sessionId: string): Promise<void> {
    try {
      const response = await fetchClient(
        `${API_BASE_URL}/chat/${sessionId}/delete/`,
        {
          method: "DELETE",
          headers: this.getAuthHeaders(token),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to delete chat session");
      }
    } catch (error) {
      console.error("Error deleting chat session:", error);
      throw error;
    }
  }

  getWebSocketUrl(sessionId: string, token: string): string {
    const tid = localStorage.getItem("tenantId");
    const base = `${WS_BASE_URL}/ws/chat/${sessionId}/?Bearer=${encodeURIComponent(token)}`;
    return tid ? `${base}&X-Tenant-Id=${encodeURIComponent(tid)}` : base;
  }
}

export const chatService = new ChatService();
